import { MultiSelect } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useEffect, useState } from 'react';

import { getBookCategories } from '@/entities/books/api/books-api';
import { Book, GetBookCategories } from '@/entities/books/model/types';

type Props = {
  setBookInfo: React.Dispatch<React.SetStateAction<Book>>;
  form: UseFormReturnType<Book>;
};

export const BookCategoriesSelect = ({ setBookInfo, form }: Props) => {
  const [categoriesData, setCategoriesData] =
    useState<GetBookCategories | null>(null);

  const categoryOptions = categoriesData?.categories.map((category) => ({
    value: String(category.id),
    label: category.title,
  }));

  const fetchBookData = async () => {
    try {
      const categoriesResponse = await getBookCategories();

      setCategoriesData(categoriesResponse);

      setBookInfo((prev) => ({
        ...prev,
        categories: categoriesResponse.categories.map(
          (category) => category.id,
        ),
      }));
    } catch (error) {
      console.error('Error loading data', error);
    }
  };

  useEffect(() => {
    fetchBookData();
  }, []);

  return (
    <MultiSelect
      mb={20}
      label="Категория"
      key={form.key('categoryIds')}
      placeholder="Выберите категорию"
      value={form.values.categoryIds?.map((id) => String(id)) || []}
      onChange={(values) =>
        form.setFieldValue(
          'categoryIds',
          values.map((v) => Number(v)),
        )
      }
      data={categoryOptions}
      required
      multiple
      clearable
      maxDropdownHeight={200}
    />
  );
};
